// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xxlargeOnWide-superElipse-f1651e7a","strokeWidth":"super-ellipse-skins-xxlargeOnWide-strokeWidth-33c244e7"};